import axiosInstance from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { IVDITransactionProps } from '@/utils/types/vdiTransaction';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { providerName } from '@/constant/gatewayTransaction/gatewayTransaction.constant';
import { ALL_PROVIDER } from '@/constant/global/global.constant';
import { isEmpty, isNil, trim } from 'lodash';
import {
  IDeleteVdiTransaction,
  IFetchVdiTransaction,
  IVdiTransaction,
} from './vdiTransaction.type';

// Define the User interface representing the structure of the user object returned by the API

export const fetchVdiTransactions = ({
  page,
  limit,
  provider,
  operatorId,
  type,
  processed,
  accepted,
  createdStartDate,
  createdEndDate,
  partnerId,
  orderBy,
  order,
  version,
  vdiTransactionId,
  status,
}: IFetchVdiTransaction): Promise<
  AxiosResponse<IVDITransactionProps[], any>
> => {
  return axiosInstance({
    url: `/vditransactions`,
    method: 'GET',
    params: {
      version,
      page,
      limit,
      ...(provider !== ALL_PROVIDER.id ? { provider } : {}),
      ...(status && !isEmpty(trim(status)) ? { status } : {}),
      operatorId,
      partnerId,
      type,
      processed,
      accepted,
      createdStartDate,
      createdEndDate,
      vdiTransactionId,
      orderBy: orderBy === providerName ? 'name' : orderBy,
      order,
    },
  });
};

export const fetchVdiTransaction = ({
  id,
  version,
}: IVdiTransaction): Promise<AxiosResponse<IVDITransactionProps>> => {
  return axiosInstance.get(
    `${API_URL_CONFIG.VDI_TRANSACTION.GET_ALL_VDI_TRANSACTIONS}/${id}`,
    {
      params: { version }, // Pass version as a parameter
    },
  );
};

export const createVdiTransaction = (
  payload: IVdiTransaction,
): Promise<AxiosResponse<IVdiTransaction>> => {
  return axiosInstance.post(
    `${API_URL_CONFIG.VDI_TRANSACTION.GET_ALL_VDI_TRANSACTIONS}`,
    payload,
  );
};

export const updateVdiTransaction = (
  id: string,
  payload: IVdiTransaction,
): Promise<AxiosResponse<IVdiTransaction>> => {
  return axiosInstance.patch(
    `${API_URL_CONFIG.VDI_TRANSACTION.GET_ALL_VDI_TRANSACTIONS}/${id}`,
    payload,
  );
};

export const deleteVdiTransaction = (
  id: IDeleteVdiTransaction,
): Promise<AxiosResponse<IDeleteVdiTransaction, any>> => {
  return axiosInstance.delete(
    `${API_URL_CONFIG.VDI_TRANSACTION.GET_ALL_VDI_TRANSACTIONS}/${id}`,
  );
};
